import { PhonePlusIcon } from './PhonePlusIcon';

/**
 * author: Google
 * id E58A5CD8-2D42-4A3A-BCC2-70870B43752C
 * name phone-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-plus.svg
 * tags
 * - Cellphone / Phone 
 */
export const AddCallIcon = PhonePlusIcon;
export default AddCallIcon